const ConsoleHelper = require('../core-helpers/console-helper.js');

const SnowplowScript = ((root, doc, undefined) => {
    'use strict';

    // Private vars
    const filename = 'snowplow-script.js';
    const productionHosts = [ 'www.busuu.com', 'org.busuu.com' ];
    const appConfig = {
        homepage: {
            trackerName: 'busuuTracker',
            appId: 'busuu Home Page'
        },
        webapp: {
            trackerName: 'busuuWebAppTracker',
            appId: 'busuu Web App'
        },
        org: {
            trackerName: 'busuuOrgTracker',
            appId: 'busuu Org'
        }
    };

    /**
     * Returns Snowplow data setup
     * (integration/production)
     * @return {Object}
     */
    const getSnowplowSetup = (appType) => {

        let endpoint = null;
        const trackerName = appConfig[appType].trackerName;
        const appId = appConfig[appType].appId;

        // Switch params endpoint if production
        if (productionHosts.indexOf(root.location.host) > -1) {
            endpoint = 'events.busuu.com';
        } else {
            endpoint = 'events-integration.busuu.com';
        }

        const params = {
            namespace: 'newTracker',
            trackerName,
            endpoint,
            appId,
            cookieDomain: '.busuu.com',
            forceUnsecureTracker: false,
            forceSecureTracker: true,
            contexts: {
                'optimizelyXSummary': true
            }
        };

        return params;
    };

    const loadSnowplow = (appType) => {

        (function(p, l, o, w, i, n, g) {
            if (!p[i]) {
                p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
                p.GlobalSnowplowNamespace.push(i);
                p[i] = function() {
                    (p[i].q = p[i].q || []).push(arguments);
                };
                p[i].q = p[i].q || [];
                n = l.createElement(o);
                g = l.getElementsByTagName(o)[0];
                n.async = 1;
                n.src = w;
                g.parentNode.insertBefore(n, g);
            }
        }(window, document, "script", "//d1fc8wv8zag5ca.cloudfront.net/2.8.0/sp.js", "snowplow"));

        /**
         * Event tracker initialisation
         * Here we configure:
         * - Tracker name: `busuuWebAppTracker` (default value is `cf`)
         * - Collector URI: `events.busuu.com`
         * We also send through the following optional parameters:
         * - appId: `busuu Web App` (used by Data team to identify app)
         * - cookieDomain: `.busuu.com` (busuu spans multiple domains, ie org.busuu.com/blog.busuu.com,
         *   this ensures that any cookies set on one subdomain will be accessible on all others)
         * - forceSecureTracker: true (forces the Collector URI to be sent via https - http is default)
         */
        const snowplowData = getSnowplowSetup(appType);
        root.snowplow(snowplowData.namespace, snowplowData.trackerName, snowplowData.endpoint, {
            appId: snowplowData.appId,
            cookieDomain: snowplowData.cookieDomain,
            forceUnsecureTracker: snowplowData.forceUnsecureTracker,
            forceSecureTracker: snowplowData.forceSecureTracker,
            contexts: snowplowData.contexts
        });
    };

    /**
     * Their documentation recommend asyncronous integration over syncronous
     * https://github.com/snowplow/snowplow/wiki/integrating-javascript-tags-onto-your-website
     * We initially tried splitting their script so that we could queue events and wait until
     * DOM load before injecting their script. However this caused errors and prevented the
     * custom event tracker from occasionally being fired so we opted to go with their
     * recommended initialisation script.
     * See: https://github.com/snowplow/snowplow/issues/3169
     */
    const init = (appType) => {

        if (!appType || !appConfig[appType]) {
            ConsoleHelper.log(filename, 'init() - missing param `appType`, cannot load Snowplow script');
            return false;
        }

        loadSnowplow(appType);
    };

    return {
        init
    };

})(window, document);

module.exports = SnowplowScript;
